import styled from 'styled-components';

export const LayoutDashboardLeftMenuSupportStyle = {
  Container: styled.div`
    .p-menu-overlay {
      transform: translateX(calc(100% + 2px));
      margin-top: -44px;
      min-width: 216px;
    }
  `,
};
